/* eslint-disable max-len */
/* eslint-disable no-console */
import { Box, Tooltip, Typography } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { GoThumbsup } from 'react-icons/go';
import { HiThumbUp } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import AvatarListPopup from '../../../../../../components/Common/AvatarListPopup';
import { LanguageContext } from '../../../../../../libs/Context';
import { catchErr } from '../../../../../../libs/HelperContent';
import { updateFeedsLike } from '../../../../../actions/feeds_actions_new';
import useGetFeedPermissions from '../../../CustomHooks/useGetFeedPermissions';
import { FeedActionContext, feedActionContext } from '../../../..';

interface Props {
	isLiked: boolean;
	feedId: string;
	feed: any;
}
const LikeButton = (props: Props) =>
{
	const { isLiked, feedId, feed } = props;
	const { language } = useContext(LanguageContext);
	const [ liked, setLiked ] = useState(Boolean(isLiked));
	const userData = useSelector((state:any) => state?.mysession?.session);
	const [ likePop, setLikepop ] = useState(false);
	const [ count, setCount ] = useState(feed?.likesCount);
	const getPermission = useGetFeedPermissions(feed, userData);
	const stopRef = useRef(false);
	const { feedAction, handleFeedAction } = useContext<FeedActionContext>(feedActionContext);

	if (!getPermission('likes')) return <></>;

	// Like update
	const handleLikeUnlike = async () =>
	{
		if (stopRef.current) return;
		stopRef.current = true;
		setLiked((prev) => !prev);
		const body = {
			feedId,
			status   : liked ? 'unlike' : 'like',
			userData : {
				firstName      : userData?.firstName,
				profileImage   : userData?.profileImage,
				companyName    : userData?.companyName,
				thumbnailImage : userData?.thumbnailImage
			}
		};
		const queryParams = {
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role
		};

		try
		{
			const res = await updateFeedsLike(body, queryParams);

			if (res?.status)
			{
				setCount(res?.data?.likesCount || (count + (liked ? -1 : 1)));
				res?.data && handleFeedAction && handleFeedAction('append', 'add_like', res?.data);
			}
			else
			{
				console.log('Failed to update your reaction');
				setLiked((prev) => !prev);
			}
		}
		catch (error)
		{
			catchErr(error);
			setLiked((prev) => !prev);
		}
		stopRef.current = false;
	};

	useEffect(() =>
	{
		if (feedId === (feedAction?.add_like?.feedId))
		{
			setCount(feedAction?.add_like?.likesCount);
			setLiked(feedAction?.add_like?.selfLike);
			handleFeedAction && handleFeedAction('remove', 'add_like');
		}
	}, [ feedAction?.add_like ]);

	return (
		<Box display='flex' alignItems='center' sx={
			{
				cursor        : !getPermission('likes') ? '' : 'pointer',
				pointerEvents : !getPermission('likes') ? 'none' : '',
				opacity       : !getPermission('likes') ? 0.5 : ''
			}}
		>
			<Tooltip title={liked ? language?.unlike : language?.like} placement='top'>
				<Box
					display='flex'
					onClick={handleLikeUnlike}
					sx={{ cursor        : 'pointer',
						color         : 'var(--greyColor)',
						'&:hover svg' : {
							backgroundColor : 'transparent',

							color     : '#23A4C4', // Hover color
							transform : 'scale(1.2)' // Hover scale
						}
					}}
				>
					{liked
						? <HiThumbUp fontSize='var(--pixel20)' color='var(--primaryColor)'/>
						: <GoThumbsup fontSize='var(--pixel20)' />
					}
				</Box>
			</Tooltip>
			<Box width={'24px'} ml={0.2} display={'flex'} height={'18px'} onClick={() => setLikepop(true)} justifyContent={'center'} alignItems={'center'} borderRadius={'8px'} bgcolor={'#d9f5fb'}>
				<Typography variant='caption' fontWeight='var(--font500)' color='var(--greyColor)'>
					{Number.isInteger(count) && count > 0 ? count : 0}
				</Typography>
			</Box>
			{likePop &&
			<AvatarListPopup
				attendees={likePop}
				title={language.likes}
				count={count}
				handleAttendeesClose={() => setLikepop(false)}
				requestType='feedLikes'
				requestId={feedId}
			/>
			}
		</Box>
	);
};

export default LikeButton;